import React from 'react';
import './TimeSelector.css';

const TimeSelector = ({ onTimeSelect, onBack }) => {
  const timeOptions = [30, 60, 90, 120];

  return (
    <div className="time-selector-overlay">
      <div className="time-selector-content">
        <h2>Select Game Duration</h2>
        <p>Choose how long you want to play:</p>
        
        <div className="time-options">
          {timeOptions.map((time) => (
            <button
              key={time}
              className="time-option"
              onClick={() => onTimeSelect(time)}
            >
              <span className="time-number">{time}</span>
              <span className="time-label">seconds</span>
            </button>
          ))}
        </div>
        
        <button className="back-btn" onClick={onBack}>
          Back to Menu
        </button>
      </div>
    </div>
  );
};

export default TimeSelector;
